import { gql } from "@apollo/client";

export const GET_TRANSACTIONS = gql`
  query GetTransactions($userId: uuid!, $limit: Int = 20, $offset: Int = 0) {
    transactions(
      where: {
        _or: [
          { physical_card: { user_id: { _eq: $userId } } }
          { virtual_card: { user_id: { _eq: $userId } } }
        ]
      }
      order_by: { processed_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      merchant_name
      amount
      status
      description
      category
      transaction_type
      processed_at
      created_at
      physical_card {
        card_name
        card_number_last_four
      }
      virtual_card {
        card_name
        card_number_last_four
      }
    }
    transactions_aggregate(
      where: {
        _or: [
          { physical_card: { user_id: { _eq: $userId } } }
          { virtual_card: { user_id: { _eq: $userId } } }
        ]
      }
    ) {
      aggregate {
        count
        sum {
          amount
        }
      }
    }
  }
`;
